$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-toimiala-matkailu/"
    };
    $("#travelForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#travelForm')[0] && $('#travelForm')[0].checkValidity()) {
            $("#travelFormSendBtn").prop("disabled", true);
            $("#travelFormSendBtn").css("background-color", "#6c757d");
            let email = $("#travelFormEmail").val();
            let firstName = $("#travelFormFirstName").val();
            let lastName = $("#travelFormLastName").val();
            let phone = $("#travelFormPhoneNumber").val();
            let message = $("#travelFormMessage").val();
            let organization = $("#travelFormOrganization").val();
            let code = "";
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phone,
                organizationName: organization,
                competitionName: "Matkailuala",
                uri: "/fi/matkailuala/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#travelFormSendBtn").prop("disabled", false);
                    $("#travelFormSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    function toggleSendButtonState() {
        const formEl = $('#travelForm')[0];
        const formValid = formEl && typeof formEl.checkValidity === 'function' ? formEl.checkValidity() : false;

        if (formValid) {
            $("#travelFormSendBtn").prop("disabled", false);
            $("#travelFormSendBtn").css("background-color", "#28a745");
        } else {
            $("#travelFormSendBtn").prop("disabled", true);
            $("#travelFormSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Watch for changes inside the travel form
    $('#travelForm input, #travelForm textarea, #travelForm select').on('input change', toggleSendButtonState);

    // Initial check
    toggleSendButtonState();
});